import { SITE_URL } from "#app/utils/structured-data.ts";

/**
 * OG card URLs and cache keys. Bump OG_CARD_VERSION whenever the card design
 * changes: the new `?v=` changes every `og:image` URL, so platforms re-fetch
 * on their next scrape, and the new cache keys leave old PNGs to expire.
 */
export const OG_CARD_VERSION = 2;

export function definitionOgImagePath(definitionId: string): string {
  return `/resources/og/${definitionId}.png?v=${OG_CARD_VERSION}`;
}

export function definitionOgImageUrl(definitionId: string): string {
  return `${SITE_URL}${definitionOgImagePath(definitionId)}`;
}

export function blogOgImageUrl(slug: string): string {
  return `${SITE_URL}/resources/og/blog/${slug}.png?v=${OG_CARD_VERSION}`;
}

export function definitionOgCacheKey(definitionId: string): string {
  return `og-image:v${OG_CARD_VERSION}:${definitionId}`;
}

export function blogOgCacheKey(slug: string): string {
  return `og-blog:v${OG_CARD_VERSION}:${slug}`;
}
